import { render, staticRenderFns } from "./CredPresOperIBS.vue?vue&type=template&id=20d015d5&"
import script from "./CredPresOperIBS.vue?vue&type=script&lang=js&"
export * from "./CredPresOperIBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports